import React from 'react';

const STATUS_OPTIONS = ['all', 'pending', 'accepted', 'cancellation_requested', 'completed', 'cancelled'];
const DATE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'today', label: 'Today' },
  { value: 'last_7', label: 'Last 7 days' },
  { value: 'last_30', label: 'Last 30 days' },
];
const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
];

function PillGroup({ options, value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map(opt => {
        const val = typeof opt === 'string' ? opt : opt.value;
        const label = typeof opt === 'string'
          ? opt.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
          : opt.label;
        const active = value === val;
        return (
          <button
            key={val}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(val)}
            className={[
              'px-3 py-1 rounded-md text-xs font-medium transition-colors duration-150',
              active
                ? 'bg-terra-400 text-white'
                : 'bg-sand-100 text-ink-600 hover:bg-sand-200',
            ].join(' ')}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default function OrderFilterPanel({
  isOpen,
  onToggle,
  statusFilter, setStatusFilter,
  datePreset, setDatePreset,
  sortDir, setSortDir,
  activeFilterCount,
  clearFilters,
}) {
  return (
    <div className="mb-4">
      {/* Trigger row */}
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls="order-filter-panel"
          className="flex items-center gap-2 px-4 py-2 rounded-md border border-sand-200 bg-white text-sm font-medium text-ink-700 hover:bg-sand-50 transition-colors duration-150"
        >
          <svg className="w-4 h-4 text-ink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h18M7 8h10M11 12h2" />
          </svg>
          Filters
          {activeFilterCount > 0 && (
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-terra-400 text-white text-xs font-semibold">
              {activeFilterCount}
            </span>
          )}
        </button>
        {activeFilterCount > 0 && (
          <button
            type="button"
            onClick={clearFilters}
            className="text-sm text-terra-400 hover:text-terra-500 font-medium transition-colors duration-150"
          >
            Clear all
          </button>
        )}
      </div>

      {/* Collapsible body */}
      {isOpen && (
        <div id="order-filter-panel" className="mt-3 p-4 bg-white border border-sand-200 rounded-lg flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Status</span>
            <PillGroup options={STATUS_OPTIONS} value={statusFilter} onChange={setStatusFilter} />
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Date</span>
            <PillGroup options={DATE_OPTIONS} value={datePreset} onChange={setDatePreset} />
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Sort</span>
            <PillGroup options={SORT_OPTIONS} value={sortDir} onChange={setSortDir} />
          </div>
        </div>
      )}
    </div>
  );
}
